import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { EventosProvider } from './context/eventosContext';
import { AuthProvider, useAuth } from './context/authContext';
import Eventos from './pages/eventos';
import Dashboard from './pages/dashboard';
import Relatorio from './pages/relatorio';
import Login from './pages/login';
import './App.css';

/**
 * Protege rotas que exigem usuário autenticado.
 */
const RotaPrivada = ({ children }) => {
  const { autenticado } = useAuth();
  return autenticado ? children : <Navigate to="/login" replace />;
};

/**
 * Impede que usuários já autenticados retornem para a tela de login.
 */
const RotaPublica = ({ children }) => {
  const { autenticado } = useAuth();
  return autenticado ? <Navigate to="/" replace /> : children;
};

function App() {
  return (
    <AuthProvider>
      <EventosProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/login"
              element={(
                <RotaPublica>
                  <Login />
                </RotaPublica>
              )}
            />
            <Route
              path="/"
              element={(
                <RotaPrivada>
                  <Eventos />
                </RotaPrivada>
              )}
            />
            <Route
              path="/dashboard"
              element={(
                <RotaPrivada>
                  <Dashboard />
                </RotaPrivada>
              )}
            />
            <Route
              path="/relatorio"
              element={(
                <RotaPrivada>
                  <Relatorio />
                </RotaPrivada>
              )}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </EventosProvider>
    </AuthProvider>
  );
}

export default App;